import { getError } from "@/utils/helpers";
import TeamService from "@/services/TeamService";
export const namespaced = true;

export const state = {
  teams: [],
  loading: false,
  error: null,
  status: null,
};

export const mutations = {
  SET_TEAMS(state, teams) {
    state.teams = teams;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getTeams({ commit }) {
    commit("SET_LOADING", true);

    TeamService.getTeams()
      .then((response) => {
        commit("SET_TEAMS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_TEAMS", []);
  },
};
export const getters = {
  teams: (state) => {
    return state.teams;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
